// 현재 망 정보
export const setNetwork = () => {
  const subdomain = {
    //opdev: ['op.', 'opdev.', 'op-', 'opdev-', 'local.', 'localhost', 'ui-static', 'file:'],
    rc: ['rc.', 'rc-', 'rc2-'],
    sb: ['sb-', '[^.]*.sb', 'local.', 'localhost'],
    opdev: ['local.plaync.com:5555'], // 통합검색 로컬만 opdev로
  };
  let env = 'live';
  let prop: keyof typeof subdomain;

  for (prop in subdomain) {
    const matchs = subdomain[prop];
    const regexp = new RegExp(`^http[s]?:\\/\\/(${matchs.join('|')})+.*`, 'i');
    if (regexp.test(window.location.href)) {
      env = prop;
    }
  }

  return env;
};
